/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actuator_Type_Sludge_RemoverInputs */



/**
* | output |
* | --- |
* | "Sludge remover" |
*
* @param {Actuator_Type_Sludge_RemoverInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_type_sludge_remover = /** @type {((inputs?: Actuator_Type_Sludge_RemoverInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_Type_Sludge_RemoverInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Sludge remover")
	return /** @type {LocalizedString} */ ("Désemboueur")
});